import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import('../support/federalDataDiagnostics/types');
import { Button } from '@pwc/appkit-react';
import { globalContextSelector } from '../../shared/store/selectors';

import AgGrid from '../../shared/displayComponents/agGrid/agGrid.component';
import { useRowEditMode } from '../../shared/editMode';

import { fetchJobQueueStatusReports, terminateStuckCalcJob } from './store/actions';
import {
  JobQueueStatusReportsSelector,
  isFetchingJobQueueStatusReportsSelector,
  isTerminatedStuckCalcJobSelector,
} from './store/selectors';
import getColumnDefinitions from './jobQueueStatusReport.columnDefinitions';

const JobQueueStatusReports = ({
  jobQueueStatusReports,
  isFetchingJobQueueStatusReports,
  fetchJobQueueStatusReports,
  jobTerminateButton,
  isTerminatedStuckCalcJob,
  terminateStuckCalcJob,
}) => {
  const getRowId = useMemo(() => ({ data }) => data?.jobId, []);
  const { taxYear, period } = useSelector(globalContextSelector);

  useEffect(() => {
    fetchJobQueueStatusReports();
  }, [fetchJobQueueStatusReports]);

  const isLoading = isFetchingJobQueueStatusReports;

  const columnDefinitions = useMemo(() => getColumnDefinitions(), []);

  const [selectedJobs, setSelectedJobs] = useState([]);

  const onSelectionChanged = useCallback(e => {
    setSelectedJobs(e.api.getSelectedRows());
  }, []);

  const handleTerminate = async () => {
    await terminateStuckCalcJob({ taxYear, period, jobs: selectedJobs });
    fetchJobQueueStatusReports();
  };

  return (
    <>
      <div className="row">
        <div className="col add-button-column">
          <Button size="md" onClick={handleTerminate} disabled={!selectedJobs.length || isLoading}>
            Terminate Job
          </Button>
        </div>
      </div>
      <div className="row grid-row">
        <div className="col">
          <AgGrid
            rowData={jobQueueStatusReports}
            columnDefs={columnDefinitions}
            rowSelection={{ mode: 'multiple' }}
            isGridLoading={isLoading}
            singleClickEdit
            onSelectionChanged={onSelectionChanged}
            withSearchBar
            getRowId={getRowId}
          />
        </div>
      </div>
    </>
  );
};

JobQueueStatusReports.propTypes = {
  jobQueueStatusReports: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      jobType: PropTypes.string.isRequired,
      submitTime: PropTypes.string.isRequired,
      mailSubject: PropTypes.string.isRequired,
      note: PropTypes.string.isRequired,
    }),
  ),
  isFetchingJobQueueStatusReports: PropTypes.bool.isRequired,
  fetchJobQueueStatusReports: PropTypes.func.isRequired,
  terminateStuckCalcJob: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    jobQueueStatusReports: JobQueueStatusReportsSelector(state),
    isFetchingJobQueueStatusReports: isFetchingJobQueueStatusReportsSelector(state),
    isTerminatedStuckCalcJob: isTerminatedStuckCalcJobSelector(state),
  }),
  {
    fetchJobQueueStatusReports,
    terminateStuckCalcJob,
  },
)(JobQueueStatusReports);
